import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Footer = () => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `);

  const aboutLinks = [
    {
      name: "Glossary",
      to: "/glossary",
    },
    {
      name: "Blog",
      to: "/blog",
    },
    {
      name: "Our Mission",
      to: "/mission",
    },
    {
      name: "Terms of Service",
      to: "/tos",
    },
    {
      name: "Privacy",
      to: "/privacy",
    },
  ];

  const topLinks = [
    {
      name: "Prompting Guide",
      to: "/blog/ai-user's-guide/mastering-prompt-engineering-with-openai-api-strategies-and-techniques-2024-05-15/",
    },
    {
      name: "Midjourney Guide",
      to: "/blog/generative-ai/getting-started-with-midjourney-v6-2024-05-15/",
    },
    {
      name: "Build Your Own Transformer",
      to: "/blog/ai-user-guides/understanding-chatgpt-from-basics-to-building-your-own-transformer-2024-05-14/",
    },
    {
      name: "Reinforcement Learning",
      to: "/blog/ai-and-machine-learning/introduction-to-reinforcement-learning-2024-05-14/",
    }
  ];

  return (
    <section>
      <div class="relative w-screen h-32 border-t-[3px] border-grey-900">
        <StaticImage
          src="../../data/images/cover.png"
          alt="Descriptive Alt Text"
          class="w-full h-full object-cover"
        />
        <div class="absolute inset-0 bg-gradient-to-b from-transparent to-white"></div>
      </div>
      <div className="h-auto pb-12 md:pb-20 2xl:px-0 px-10 font-questrial">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 items-start justify-between">
          <div className="space-y-5 pr-10">
            <h4 className="text-3xl font-bold">
              {data.site.siteMetadata.title}
            </h4>
            <p>
              {data.site.siteMetadata.description}
            </p>
            <p>
              © {new Date().getFullYear()} {data.site.siteMetadata.title}
            </p>
            <a href="mailto:hello@usersguidetoai.com" className="block underline">
              hello@usersguidetoai.com
            </a>
          </div>
          <div className="pt-2">
            <h4 className="text-2xl mb-5">Top Posts</h4>
            <ul className="relative space-y-2 list-none pl-0">
            {topLinks.map((item, index) => (
                <li>
                  <Link to={item.to} key={index} className="hover:underline">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="pt-2">
            <h4 className="text-2xl mb-5">About Us</h4>
            <ul className="relative space-y-2 list-none pl-0">
              {aboutLinks.map((item, index) => (
                <li>
                  <Link to={item.to} key={index} className="hover:underline">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="pt-2">
            <h4 className="text-2xl mb-5">Our Mission</h4>
            <p>
              Advance your understanding of AI with cutting-edge insights,
              tools, and expert tips.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
